import React, {useContext, useEffect} from "react";
import $ from "jquery";
import BackofficeContext from "../../context/BackofficeContext";
import "../../css/warning/Warning.css";

const WarningMessage = props => {
    const { setWarningText } = useContext(BackofficeContext);

    const cleanError = () => {
        $(".backoffice > .warningMessage").addClass("disappear");

        setTimeout(() => {
            setWarningText(null);
        }, 500);
    }

    useEffect(() => {
        let timeout = setTimeout(() => { cleanError() }, 4000);

        return() => {
            clearTimeout(timeout);
        }
    }, []);

    return (
        <p className={"warningMessage"}>
            {
                props.message
            }
        </p>
    )
}

export default WarningMessage;
